import { classes } from './BusinessDashboard.st.css';

import { CircleLoaderCheck } from './icons';

export default ({ active } = {}) => ({
  className: active === false ? '' : classes.root,
  icons: {
    CircularProgressBar: {
      small: CircleLoaderCheck,
      medium: CircleLoaderCheck,
      large: CircleLoaderCheck,
    },
  },
});
